import Client from 'shopify-buy';
import * as ls from 'local-storage';

// see https://shopify.github.io/js-buy-sdk/ for Shopify API reference

export default class ShopifyService {
    constructor(client) {
        this.client = client;
    }
    static createClient(domain, storefrontAccessToken) {
        return Client.buildClient({
            domain,
            storefrontAccessToken
        });
    }
    getAllProducts() {
        return this.client.product.fetchAll();
    }
    getProductsForCollection(collectionId) {
        return this.client.collection.fetchWithProducts(collectionId);
    }
    getProduct(productId) {
        return this.client.product.fetch(productId)
    }
    getProductGroups() {
        return this.client.collection.fetchAllWithProducts();
    }
    getGroupProducts(groupId) {
        return this.client.collection.fetchWithProducts(groupId);
    }
    createCheckout() {
        return this.client.checkout.create();
    }
    getCheckout(id) {
        return this.client.checkout.fetch(id);
    }
    setCartAttribute(checkoutId, key, value) {
        const input = { customAttributes: { key, value } };
        return this.client.checkout.updateAttributes(checkoutId, input)
    }
    addProductToCart(cartId, product, quantity = 1) {
        return this.client.checkout.addLineItems(cartId, [
            {
                variantId: product.id,
                quantity,
                customAttributes: []
            }
        ])
    }
    updateLineItem(cartId, lineItem, quantity) {
        return this.client.checkout.updateLineItems(cartId, [{
            id: lineItem.id,
            quantity
        }])
    }
    removeVariantsFromCart(cartId, variants) {
        return this.client.checkout.removeLineItems(cartId, variants);
    }
    get previousCartId() {
        return ls.get('shopify-last-cart-id');
    }
    set previousCartId(value) {
        ls.set('shopify-last-cart-id', value);
    }
}